<app-breadcrumb></app-breadcrumb>
<div class="content ms-4 me-4">
    <h2 class="roboto-medium title">AET Notifications</h2>

    <div class="filter-section justify-content-between">
         <form [formGroup]="notificationFilterForm" class="filter-form">
            <input formControlName="name" placeholder="Enter Name" class="mb-1 me-2" style="height: 35px;"/>
            <input formControlName="userIds" placeholder="Enter User ID" class="mb-1 me-2" style="height: 35px;"/>
            <button class="b2 mb-1 me-2" (click)="filterData()" type="button">Filter</button>
            <button class="b2 mb-1 me-2" (click)="resetFilter()" type="button">Reset Filter</button>
        </form> 
        
        <button class="mb-1 me-2 black-button" (click)="openNotificationDialog()" type="button">Create Notification</button>
    </div>
    <div class="grid-agg px-0" >
    <!-- AG Grid Table --> 
     <!--<div class="notify-ag-grid"> -->
        <ag-grid-angular [ngStyle]="{
            height: dynamicHeight + 'px',
            width: '100%',
            'font-family': 'Roboto'
          }"
        class="ag-theme-balham grid-items notification-grid" [rowData]="filteredNotifications"
        [columnDefs]="columnDefs" [gridOptions]="gridOptions"  [rowHeight]="30" [pagination]="true"
        (gridReady)="onGridReady($event)" [rowClassRules]="rowClassRules" [tooltipShowDelay]="tooltipShowDelay"
        [tooltipHideDelay]="tooltipHideDelay" [remoteGridBinding]="remoteGridBinding"
        [tooltipMouseTrack]="tooltipMouseTrack"  [getRowStyle]="getRowStyle" 
        [masterDetail]="true"
      [gridOptions]="gridOptions"
      [rowClassRules]="rowClassRules"
      [pagination]="true"
      [headerHeight]="40"
      (paginationChanged)="onPaginationChanged()"
      [pagination]="true"
      [paginationPageSize]="paginationPageSize"
      [suppressPaginationPanel]="true"
      (filterChanged)="onFilterChanged($event)"
      (modelUpdated)="onModelUpdated()" [icons]="icons" [theme]="'legacy'"> 
    </ag-grid-angular> 
    <div
    class="d-flex pagination px-2 align-items-center justify-content-between"
  >
    <div>
      <div>
        <label class="page-drpdwn-label me-2">Records/Page: </label>
        <select (change)="onPageSizeChanged($event)" class="paginate_drpdwn">
          <option value="5">5</option>
          <option value="10">10</option>
          <option value="20" selected>20</option>
          <option value="50">50</option>
          <option value="{{ rowCount }}">ALL</option>
        </select>
      </div>
    </div>
    <div class="d-flex align-items-center gap-3">
      <div>Viewing Records</div>

      <img
        src="assets/images/Icon awesome-fast-forward.svg"
        width="10"
        (click)="goToFirstPage()"
        class="text-primary reverse firstPage"
        [ngClass]="{
          disable_icon: getCurrentPage() == true,
          enable_icon: getCurrentPage() != true
        }"
      />

      <img
        src="assets/images/Icon metro-next.svg"
        (click)="goToPreviousPage()"
        class="text-primary reverse previousPage"
        [ngClass]="{
          disable_icon: getCurrentPage() == true,
          enable_icon: getCurrentPage() != true
        }"
      />

      <div>
        (
        <span class="value" id="lbCurrentPage"></span> -
        <span class="value" id="lbTotalPages"></span>)&nbsp; OF &nbsp;
        <span>{{ rowCount }}</span>
      </div>

      <img
        src="assets/images/Icon metro-next.svg"
        (click)="goToNexpage()"
        class="text-primary nextPage"
        [ngClass]="{
          disable_icon: isLastPage() == true || rowCount == 0,
          enable_icon: isLastPage() != true || rowCount > 0
        }"
      />
      <img
        src="assets/images/Icon awesome-fast-forward.svg"
        width="10"
        (click)="goToLastPage()"
        class="text-primary lastPage"
        [ngClass]="{
          disable_icon: isLastPage() == true || rowCount == 0,
          enable_icon: isLastPage() != true || rowCount > 0
        }" />
      </div>
    </div>
 
    </div>


</div> 
  <ng-template #confirmationDialog let-dialog>
    <div class="popup-container">
    <h2 mat-dialog-title>{{ dialogData.title }}</h2>
    <mat-dialog-content>{{ dialogData.message }}</mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="dialogRef.close(false)">Cancel</button>
      <button mat-button color="primary" (click)="dialogRef.close(true)">Confirm</button>
    </mat-dialog-actions>
    </div>
  </ng-template>
  
<ng-template #notificationDialog let-dialog>
    <div class="popup-container">
        <h2 mat-dialog-title>{{ dialogData.title }}</h2>
        <mat-dialog-content>{{ dialogData.message }}</mat-dialog-content>
        <mat-dialog-actions align="end">
            <button mat-button (click)="dialogRef.close(false)">Ok</button>
        </mat-dialog-actions>
    </div>
</ng-template>